import { STATUS } from "@/constants/statuses";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { WishlistWithItemsEntity } from "../entities/WishlistWithItemsEntity";

export interface WishlistsState
    extends EntityState<WishlistWithItemsEntity, number> {
    itemsTotalCount: number;
    status: STATUS;
    saveStatus: STATUS;
    loadMoreStatus: STATUS;
    createDraftOrderStatus: STATUS;
    sendNotificationToApproversStatus: STATUS;
    approveWishlistStatus: STATUS;
}

export function createInitialState(): WishlistsState {
    return {
        itemsTotalCount: 0,
        status: STATUS.VIRGIN,
        saveStatus: STATUS.VIRGIN,
        loadMoreStatus: STATUS.VIRGIN,
        createDraftOrderStatus: STATUS.VIRGIN,
        sendNotificationToApproversStatus: STATUS.VIRGIN,
        approveWishlistStatus: STATUS.VIRGIN,
    };
}

@singleton()
@StoreConfig({ name: "wishlists" })
class WishlistsStore extends EntityStore<WishlistsState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status,
        }));
    }

    setSaveStatus(saveStatus: STATUS) {
        this.update(() => ({
            saveStatus,
        }));
    }

    setLoadMoreStatus(loadMoreStatus: STATUS) {
        this.update(() => ({
            loadMoreStatus,
        }));
    }

    setCreateDraftOrderStatus(createDraftOrderStatus: STATUS) {
        this.update(() => ({
            createDraftOrderStatus,
        }));
    }

    setSendNotificationToApproversStatus(
        sendNotificationToApproversStatus: STATUS
    ) {
        this.update(() => ({
            sendNotificationToApproversStatus,
        }));
    }

    setApproveWishlistStatus(approveWishlistStatus: STATUS) {
        this.update(() => ({
            approveWishlistStatus,
        }));
    }
}

export default WishlistsStore;
